var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.component.attributes),function(attribute){return _c('mercado-libre-attribute-input',{key:attribute.id,attrs:{"attribute":attribute,"previous":_vm.$dig(_vm.previous, attribute.id, 'value')},on:{"input":_vm.input}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }